<template>
  <div
    :class="bem({
      gradient,
      gradientDirection: gradient && gradientDirection,
      gradientTheme: gradient && gradientTheme
    })"
    :style="{
      height: gradient && gradientHeight,
      opacity: gradient ? 1 : overlayOpacity / 100
    }"
  />
</template>

<script>
export default {
  name: 'BaseOverlay',

  props: {
    overlayOpacity: {
      type: Number,
      default: 0
    },
    gradient: {
      type: Boolean,
      default: false
    },
    gradientDirection: {
      type: String,
      default: 'top-down',
      validator: value => ['top-down', 'bottom-up'].includes(value)
    },
    gradientHeight: {
      type: String,
      default: '100%'
    },
    gradientTheme: {
      type: String,
      default: '',
      validator: value => ['', 'black', 'white'].includes(value)
    }
  },

  setup () {
    return {
      bem: useBEM('BaseOverlay')
    }
  }
}
</script>

<style lang="postcss">
.BaseOverlay {
  @apply absolute
    top-0 left-0
    h-full w-full
    bg-black
    pointer-events-none;

  &--gradient {
    @apply bg-transparent from-[#131313]/50;

    &-theme-black {
      @apply from-black/30;
    }

    &-theme-white {
      @apply from-white/30;
    }
  }

  &--gradient-direction-top-down {
    @apply bg-gradient-to-b;
  }

  &--gradient-direction-bottom-up {
    @apply top-auto bottom-0
      bg-gradient-to-t;
  }
}
</style>
